<template name="ModalText">
  <div class="modal-text"><slot /></div>
</template>
<style scoped lang="scss">
@import '@/popup/styles/typography';

.modal-text {
  letter-spacing: 0;
  text-align: center;
  padding-bottom: 24px;

  @extend %paragraph-inter-14-regular;
}
</style>
